// All login codes are defined here

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  /** Login API codes */
  TO_MANY_ATTEMPTS: 29,
  USER_NOT_FOUND: 92,
  INVALID_CREDENTIALS: 41,
  CHANGE_TEMPORARY_PASSWORD: 93,
  /** Forget Password API codes */
  NO_USER_FOUND: 41,
  PASSWORD_CHANGED: 20,
  USER_DEACTIVATED: 91,
  SIGNED_IN: 20,
  OTP_SENT_TO_MAIL: 25,
  INVALID_OTP: 40,
  /** Verify OTP API codes */
  OTP_TIME_EXPIRED: 41,
  NO_USER_FOUND_OTP: 41,
  /** Resend OTP API codes */
  WRONG_OTP: 41,
  USER_VERIFY_OTP_SENT: 21,
  USER_VERIFIED: 20,
};
